import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { getMapKey } from '@/lib/utils';

export declare namespace NumberState {
}

export interface NumberState {
    recommend: {
        [activityId_number: string]: number[],
    };
    letter: string;
}

const m: Module<NumberState, RootState> = {
    namespaced: true,
    state: {
        recommend: {},
        letter: '',
    },
    mutations: {
        setRecommend(state, { key, list }) {
            Vue.set(state.recommend, key, list);
        },
        setLetter(state, letter) {
            state.letter = letter;
        },
    },
    actions: {
        async getRecommend({state, commit}, { activity_id, number }: { activity_id: string; number: number }) {
            const params = { activity_id };
            if (number) {
                Object.assign(params, { number });
            }
            const res = await Vue.axios.get('/api/v1/code_book/recommend', {
                params,
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                const key = getMapKey({
                    activity_id,
                    number,
                });
                commit('setRecommend', {
                    key, list: rdata.data,
                });
            }
            return rdata;
        },
        async getLetter({commit}, activity_id: string) {
            const res = await Vue.axios.get('/api/v1/code_book/letter', {
                params: { activity_id },
            });
            const rdata = res.data;
            if (rdata.status === 0) {
                commit('setLetter', rdata.data);
            }
            return rdata;
        },
        async checkCode(context, {
            activity_id,
            code,
            letter,
        }: {
            /** 活动id */
            activity_id: string
            /** 字母 */
            letter: string
            /** 号码 */
            code: string,
        }) {
            const res = await Vue.axios.post('/api/v1/code_book', {
                activity_id,
                code: code.replaceAll(' ', '').slice(0, 5),
                letter,
                from_path: location.href
            });
            const rdata = res.data;
            return rdata;
        },
    },
};

export default m;
